<template>
  <page-view title="数据字典详情">
  <a-card :bordered="false">
        <detail-list :col="2">
            <detail-list-item term="字典名称">{{dictModel.name}}</detail-list-item>
            <detail-list-item term="字典标识">{{dictModel.keyword}}</detail-list-item>
            <detail-list-item term="是否缓存">{{dictModel.enableCache === 1 ? '是' : '否'}}</detail-list-item>
            <detail-list-item term="描述">{{dictModel.remark}}</detail-list-item>
        </detail-list>
        <div class="table-operator">
            <a-button type="primary" icon="plus" @click="onAddItem">添加字典项</a-button>&nbsp;
            <a-button v-if="selectedTreeNode" type="primary" icon="edit" @click="onEditItem">修改字典项</a-button>&nbsp;
            <a-popconfirm title="是否确认删除？" @confirm="onDeleteItem">
                <a-button v-if="selectedTreeNode" type="primary" icon="delete">删除字典项</a-button>
            </a-popconfirm>
        </div>
        <a-row class="tree-container">
            <a-col :span="7">
                <div>字典项：</div>
                <a-tree showLine :expandedKeys="treeExpandedKeys" :loadedKeys="treeLoadedKeys" :treeData="treeData" @expand="onTreeExpand" :loadData="onTreeLoadData" @select="onTreeSelect" />
            </a-col>
            <a-col :span="17" class="tree-detail">
                <table class="fx-form-view">
                    <tr>
                        <th>字典名称</th>
                        <td>{{selectedModel.title}}</td>
                    </tr>
                    <tr>
                        <th>字典取值</th>
                        <td>{{selectedModel.value}}</td>
                    </tr>
                    <tr>
                        <th>排序号</th>
                        <td>{{selectedModel.seqNo}}</td>
                    </tr>
                    <tr>
                      <th>状态</th>
                      <td>
                        <a-tag v-if="selectedModel.state === 'E'" color="green">启用</a-tag>
                        <a-tag v-else-if="selectedModel.state === 'D'" color="red">禁用</a-tag>
                      </td>
                    </tr>
                    <tr>
                        <th>描述</th>
                        <td>{{selectedModel.remark}}</td>
                    </tr>
                </table>
            </a-col>
        </a-row>
        <DictItemEdit ref="dictItemEdit" :dictId="dictId" @success="onSaveSuccess"/>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import { axios as request } from '@/utils/request'
import DetailList from '@/components/tools/DetailList'
import DictItemEdit from './DictItemEdit'

const DetailListItem = DetailList.Item

export default {
  name: 'DictPanel',
  components: {
    PageView,
    DetailList,
    DetailListItem,
    DictItemEdit
  },
  created () {
    this.loadDict()
    this.loadDictItem('')
  },
  data () {
    return {
      dictId: this.$route.query.id,
      dictModel: {},
      selectedTreeNode: null,
      selectedModel: {},
      treeExpandedKeys: [],
      treeLoadedKeys: [],
      treeData: [],
      modalVisible: false
    }
  },
  methods: {
    reloadTree () {
      this.$router.go(0)
      /*
      this.selectedTreeNode = null
      this.selectedModel = {}
      this.loadDictItem('')
      */
    },
    onTreeExpand (expandedKeys) {
      this.treeExpandedKeys = expandedKeys
    },
    onTreeLoadData (treeNode) {
      this.selectedTreeNode = treeNode
      if (treeNode.dataRef.children) {
        return new Promise(function (resolve, reject) {
          resolve()
        })
      }
      return this.loadDictItem(treeNode.dataRef.key)
    },
    loadDict () {
      let that = this
      return request.get('/api/1/dict/dict.json?id=' + this.dictId).then(function (response) {
        that.dictModel = response.result
      })
    },
    loadDictItem (parentId) {
      let that = this
      return request.get('/api/1/dict/admin/items.json?dictId=' + this.dictId + '&id=' + parentId).then(function (response) {
        if (that.selectedTreeNode == null) {
          that.treeData = that.mapTreeData(response.result)
        } else {
          that.selectedTreeNode.dataRef.children = that.mapTreeData(response.result)
          that.treeData = [...that.treeData]
        }
      })
    },
    onTreeSelect (selectedKeys, info) {
      const item = info.node.dataRef
      let expanded = this.treeExpandedKeys.includes(item.key)
      // 如果不是叶子节点，则展开节点（易用性）
      if (!item.isLeaf) {
        if (info.selected) {
          // 点击了节点名称，如果还没展开，则展开
          if (!expanded) {
            this.treeExpandedKeys.push(item.key)
          }
        } else {
          // 取消点击了节点名称，如果已经展开，则移除
          if (expanded) {
            this.treeExpandedKeys = this.treeExpandedKeys.filter(id => id !== item.key)
          }
        }
      }

      if (selectedKeys.length === 0) {
        this.selectedTreeNode = null
      } else {
        this.selectedTreeNode = info.node
      }
      this.getDictItemInfo(item.key)
    },
    getDictItemInfo (itemId) {
      const that = this
      that.moduleLoading = true
      that.$http.get('/api/1/dict/dict-item.json?id=' + itemId).then(function (resp) {
        that.selectedModel = that.mapTreeNode(resp.result)
      })
    },
    onAddItem () {
      if (this.selectedTreeNode !== null) {
        this.$refs.dictItemEdit.preAdd(this.selectedModel.key)
      } else {
        this.$refs.dictItemEdit.preAdd(null)
      }
    },
    onEditItem () {
      this.$refs.dictItemEdit.preEdit(this.selectedModel.key)
    },
    onSaveSuccess (parentId) {
      this.reloadTreeNode(parentId)
      if (this.selectedModel.key) {
        this.getDictItemInfo(this.selectedModel.key)
      } else {
        this.selectedModel = {}
      }
    },
    onDeleteItem () {
      let that = this
      request.post('/api/1/dict/admin/item_delete.json?id=' + this.selectedModel.key).then(function (resp) {
        that.$message.success('删除字典项成功')
        that.reloadTreeNode(resp.result.parentId)
        that.selectedModel = {}
      })
    },
    mapTreeData (list) {
      return list.map(item => {
        return this.mapTreeNode(item)
      })
    },
    mapTreeNode (item) {
      return {
        key: item.id,
        title: item.name,
        isLeaf: !item.hasChildren,
        value: item.value,
        seqNo: item.seqNo,
        state: item.state,
        remark: item.remark
      }
    },
    reloadTreeNode (treeNodeId) {
      this.$http.get('/api/1/dict/admin/items.json?dictId=' + this.dictId + '&id=' + treeNodeId).then(resp => {
        if (treeNodeId) {
          this.replaceTreeNodeChildren(this.treeData, treeNodeId, this.mapTreeData(resp.result))
        } else {
          this.treeData = this.mapTreeData(resp.result)
        }
      })
    },
    replaceTreeNodeChildren (treeData, treeNodeId, children) {
      treeData.forEach(item => {
        if (item.key === treeNodeId) {
          item.isLeaf = children.length === 0
          let loadedKeys = this.getTreeNodeKeys([item], 0)
          this.treeLoadedKeys = this.treeLoadedKeys.filter(key => !loadedKeys.includes(key))
          this.treeExpandedKeys = this.treeExpandedKeys.filter(key => !loadedKeys.includes(key))
          this.$set(item, 'children', children)
          this.$forceUpdate()
        } else {
          if (item.children) {
            this.replaceTreeNodeChildren(item.children, treeNodeId, children)
          }
        }
      })
    },
    getTreeNodeKeys (treeNodes, level) {
      let keys = []
      treeNodes.forEach(node => {
        if (level > 0) {
          keys.push(node.key)
        }
        if (node.children) {
          keys = keys.concat(this.getTreeNodeKeys(node.children, ++level))
        }
      })
      return keys
    }
  }
}
</script>

<style scoped>
    .table-operator {
        margin-bottom: 14px;
    }
</style>
